/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable camelcase */

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { handleMessages } from '../../_helpers/utilities'
import {
  ISuperAdminConfigurationState,
  IUpdateConfigurationPayload,
} from '../../_models/superAdmin/configurationInterface'
import * as configurationService from '../../_services/superAdmin/configurationService'
import { RootState } from '../../_store/store'
import { startLoader, stopLoader } from '../loaderSlice'
import { errorToast, successToast } from '../toastSlice'
const initialState: ISuperAdminConfigurationState = {
  configurationDetails: {
    site: [],
    booking: [],
    map: [],
    admin: [],
  },
}

export const getSuperAdminConfigurationDetails = createAsyncThunk(
  '/getSuperAdminConfigurationDetails',
  async (_, { dispatch, rejectWithValue }) => {
    dispatch(startLoader())
    try {
      const response = await configurationService.getSuperAdminConfigurationDetails()
      dispatch(stopLoader())
      return response
    } catch (err: any) {
      dispatch(stopLoader())
      dispatch(errorToast(handleMessages(err.message)))
      return rejectWithValue(err)
    }
  },
)
export const updateSuperAdminConfigurationDetails = createAsyncThunk(
  '/updateSuperAdminConfigurationDetails',
  async (params: IUpdateConfigurationPayload, { dispatch, rejectWithValue }) => {
    dispatch(startLoader())
    try {
      const response = await configurationService.updateSuperAdminConfigurationDetails(params)
      dispatch(successToast(handleMessages(response.message)))
      dispatch(getSuperAdminConfigurationDetails())
      dispatch(stopLoader())
      return response
    } catch (err: any) {
      dispatch(stopLoader())
      dispatch(errorToast(handleMessages(err.message)))
      return rejectWithValue(err)
    }
  },
)
export const superAdminConfigurationSlice = createSlice({
  name: 'superAdminConfiguration',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getSuperAdminConfigurationDetails.fulfilled, (state, action) => {
      state.configurationDetails = action.payload.data
      state.configurationDetails.site = action.payload.data?.Site
      state.configurationDetails.booking = action.payload.data?.Booking
      state.configurationDetails.map = action.payload.data?.Map
      state.configurationDetails.admin = action.payload.data?.Admin
    })
  },
})

export const superAdminConfigurationState = (state: RootState) => state.superAdminConfiguration
const superAdminConfigurationReducer = superAdminConfigurationSlice.reducer
export default superAdminConfigurationReducer
